module.exports = __webpack_public_path__ + "img/news_banner.d909da0f.png";